import { useState } from 'react';

interface SpecialsPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SpecialsPopup({ isOpen, onClose }: SpecialsPopupProps) {
  if (!isOpen) return null;

  // Check if current date is after January 31, 2026
  const currentDate = new Date();
  const expiryDate = new Date('2026-01-31T23:59:59');
  const isExpired = currentDate > expiryDate;

  return (
    <div className="fixed inset-0 bg-black/95 z-50 overflow-y-auto">
      <div className="min-h-screen px-6 py-12 flex items-center justify-center">
        <div className="max-w-5xl mx-auto w-full">
          <div className="flex items-center justify-end mb-6">
            <button
              onClick={onClose}
              className="w-12 h-12 flex items-center justify-center bg-zinc-800 hover:bg-zinc-700 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-white text-2xl"></i>
            </button>
          </div>

          {isExpired ? (
            // Coming Soon Page
            <div className="bg-gradient-to-b from-zinc-900 to-black rounded-lg p-16 text-center">
              <div className="w-24 h-24 bg-amber-400/10 rounded-full flex items-center justify-center mx-auto mb-8">
                <i className="ri-time-line text-amber-400 text-5xl"></i>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
                Coming Soon
              </h2>
              <p className="text-gray-400 text-lg mb-8 max-w-2xl mx-auto">
                New exclusive specials are on the way. Check back soon for incredible deals on your next Mercedes-Benz.
              </p>
              <div className="flex items-center justify-center gap-2 mb-12">
                <div className="w-3 h-3 bg-amber-400 rounded-full animate-pulse"></div>
                <div className="w-3 h-3 bg-amber-400 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
                <div className="w-3 h-3 bg-amber-400 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
              </div>
            </div>
          ) : (
            // Current Specials Image
            <div className="bg-white rounded-lg overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/2cff082c3240b86a1a45c3f20eab75c2/bcff93b094203433021c3fa91497668f.png"
                alt="January Specials - Suburban Cook County Tax Included"
                className="w-full h-auto"
              />
            </div>
          )}

          <div className="text-center mt-8">
            <button
              onClick={onClose}
              className="bg-amber-400 text-black font-semibold px-12 py-4 rounded-lg hover:bg-amber-500 transition-colors duration-300 whitespace-nowrap cursor-pointer text-lg"
            >
              Back to Inventory
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
